// =============================================================================
// FILE PATH : src/modules/pms/wbs_template/services/wbsTemplateService.js
// MODULE    : PMS → WBS Template Integration
// PURPOSE   : Service layer for fetching template library and applying templates
// =============================================================================

import axiosClient from "../../../../api/axiosClient";


// -----------------------------------------------------------------------------
// GET TEMPLATE LIBRARY
// -----------------------------------------------------------------------------
export const getTemplateLibrary = async () => {
  try {
    const response = await axiosClient.get(
      "/api/pms/task-template/library"
    );

    // Expected:
    // {
    //   success: true,
    //   data: {
    //     project_templates: [],
    //     equipment_templates: []
    //   }
    // }

    return response.data;

  } catch (error) {
    console.error("Error fetching template library:", error);
    throw error;
  }
};


// -----------------------------------------------------------------------------
// APPLY TEMPLATE TO WBS
// -----------------------------------------------------------------------------
export const applyTemplateToWBS = async ({
  project_id,
  parent_id,

  // 🔥 NEW
  template_name,
  template_type,

  tasks
}) => {

  try {

    const payload = {
      project_id,
      parent_id,

      // 🔥 IMPORTANT
      template_name,
      template_type,

      tasks
    };

    const response = await axiosClient.post(
      "/api/pms/task-template/apply",
      payload
    );

    return response.data;

  } catch (error) {
    console.error("Error applying template to WBS:", error);
    throw error;
  }
};